export default function AvisoLegal() {
  return (
    <div data-testid="aviso-legal-page" className="py-20">
      <div className="container-max max-w-3xl">
        <div className="mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-3">Aviso legal</h1>
        </div>

        <div className="prose-article">
          <h2>1. Datos identificativos</h2>
          <p>
            En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002 de 11 de
            julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se
            reflejan los siguientes datos:
          </p>
          <p>
            La empresa titular del dominio web es <strong>DOCTORES PINA SLP</strong> con NIF <strong>B64523616</strong>{" "}
            y con dirección a estos efectos en <strong>Travessera de les Corts 82 bjs-08028 Barcelona</strong>,
            en adelante LA CLÍNICA.
          </p>

          <h2>2. Aceptación del Usuario</h2>
          <p>
            Este Aviso Legal regula el acceso y utilización de la página web que LA CLÍNICA pone a disposición
            de los usuarios de Internet. Se entiende por usuario la persona que acceda, navegue, utilice o
            participe en los servicios y actividades de la Web. El acceso y navegación de un usuario por la Web
            implica la aceptación sin reservas del presente Aviso Legal. LA CLÍNICA puede ofrecer a través de la
            página web servicios que podrán encontrarse sometidos a unas condiciones particulares propias sobre
            las cuales se informará al Usuario en cada caso concreto.
          </p>

          <h2>3. Utilización de la web</h2>
          <p>
            <strong>3.1.</strong> El usuario se compromete a utilizar la Web, los contenidos y servicios de
            conformidad con la Ley, el presente Aviso Legal, las buenas costumbres y el orden público.
          </p>
          <p>
            <strong>3.2.</strong> El usuario se compromete expresamente a no destruir, alterar, inutilizar o,
            de cualquier otra forma, dañar los datos, programas o documentos electrónicos y demás que se encuentren
            en la Web.
          </p>
          <p>
            <strong>3.3.</strong> El usuario se compromete a no obstaculizar el acceso a otros usuarios al servicio
            de acceso mediante el consumo masivo de los recursos informáticos, así como realizar acciones que dañen,
            interrumpan o generen errores en dichos sistemas o servicios.
          </p>
          <p>
            <strong>3.4.</strong> El usuario se compromete a no introducir programas, virus, macros, applets,
            controles ActiveX o cualquier otro dispositivo lógico o secuencia de caracteres que causen o sean
            susceptibles de causar cualquier tipo de alteración en los sistemas informáticos de LA CLÍNICA o de
            terceros.
          </p>
          <p>
            <strong>3.5.</strong> El usuario se compromete a no obtener informaciones, mensajes, gráficos, dibujos,
            archivos de sonido y/o imagen, fotografías, grabaciones, software y en general, cualquier clase de
            material accesible a través de la Web o de los servicios ofrecidos en el mismo.
          </p>
          <p>
            <strong>3.6.</strong> Se entiende que el acceso o utilización de la Web por parte del usuario implica
            la aceptación por éste del Aviso Legal que LA CLÍNICA tenga publicado en el momento del acceso.
          </p>
          <p>
            <strong>3.7.</strong> El usuario se compromete a hacer un uso adecuado de los contenidos y servicios
            y a no emplearlos para incurrir en actividades ilícitas o contrarias a la buena fe y al ordenamiento
            legal; difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico-ilegal, de apología
            del terrorismo o atentatorio contra los derechos humanos.
          </p>

          <h2>4. Acceso a la web</h2>
          <p><strong>4.1.</strong> El acceso a la Web por parte de los usuarios tiene carácter libre y gratuito.</p>
          <p>
            <strong>4.2.</strong> Cuando sea necesario que el usuario se registre o aporte datos personales para
            poder acceder a alguno de los servicios, la recogida y el tratamiento de los datos personales de los
            usuarios será de aplicación lo dispuesto en nuestra Política de Privacidad.
          </p>
          <p>
            <strong>4.3.</strong> Queda prohibida la contratación de productos o servicios a través de la Web
            por parte de menores de edad, debiendo obtener debidamente y con anterioridad, el consentimiento de
            sus padres, tutores o representantes legales.
          </p>
          <p>
            <strong>4.4.</strong> Si para la utilización de un servicio en la Web, el usuario debiera proceder a
            su registro, éste será responsable de aportar información veraz y lícita.
          </p>

          <h2>5. Modificaciones del Aviso Legal</h2>
          <p>
            LA CLÍNICA se reserva expresamente el derecho a modificar el presente Aviso Legal. El usuario reconoce
            y acepta que es su responsabilidad revisar la Web y el presente Aviso Legal.
          </p>

          <h2>6. Exclusión de garantías y responsabilidad</h2>
          <p>
            <strong>6.1.</strong> LA CLÍNICA se compromete a realizar sus mejores esfuerzos para evitar cualquier
            error en los contenidos que pudieran aparecer en la Web. En cualquier caso, LA CLÍNICA estará exenta
            de cualquier responsabilidad derivada de eventuales errores en los contenidos, siempre que no le sean
            imputables.
          </p>
          <p>
            <strong>6.2.</strong> LA CLÍNICA no garantiza que la Web y el servidor estén libres de virus y no se
            hace responsable de los posibles daños o perjuicios que se puedan derivar de interferencias, omisiones,
            interrupciones, virus informáticos, averías telefónicas o desconexiones en el funcionamiento operativo.
          </p>

          <h2>7. Propiedad intelectual e industrial</h2>
          <p>
            <strong>7.1.</strong> Todos los derechos de Propiedad Industrial e Intelectual de la Web y de sus
            contenidos (textos, imágenes, sonidos, audio, vídeo, diseños, creatividades, software) pertenecen,
            como autor de obra colectiva o como cesionaria, a LA CLÍNICA o, en su caso, a terceras personas.
          </p>
          <p>
            <strong>7.2.</strong> Quedan expresamente prohibidas la reproducción, la distribución y la comunicación
            pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de
            esta página Web, con cualquier fin, en cualquier soporte y por cualquier medio técnico, sin la autorización
            de LA CLÍNICA.
          </p>
          <p>
            <strong>7.3.</strong> A los efectos de lo previsto en el artículo 32.1 del Texto Refundido de la Ley
            de Propiedad Intelectual, LA CLÍNICA se opone expresamente a la utilización de cualesquiera contenidos
            de este portal web con la finalidad de realizar reseñas con fines comerciales sin contar con la previa
            autorización de LA CLÍNICA.
          </p>
          <p>
            <strong>7.4.</strong> El usuario puede visualizar todos los elementos, imprimirlos, copiarlos y
            almacenarlos en el disco duro de su ordenador o en cualquier otro soporte físico siempre y cuando sea,
            única y exclusivamente, para su uso personal y privado.
          </p>
          <p>
            <strong>7.5.</strong> LA CLÍNICA proporciona el acceso a todo tipo de informaciones, servicios, programas
            o datos en Internet que pueden pertenecer a terceras personas, en cuyo caso LA CLÍNICA no se hace
            responsable de dichos contenidos ni de cuantas reclamaciones puedan derivarse.
          </p>

          <h2>8. Enlaces de Terceros</h2>
          <p>
            <strong>8.1.</strong> En el supuesto de que en la Web se dispusieran enlaces o hipervínculos hacia otros
            lugares de Internet, LA CLÍNICA no ejercerá ningún tipo de control sobre estos lugares y contenidos.
          </p>
          <p>
            <strong>8.2.</strong> Estos enlaces se proporcionan únicamente para informar al Usuario sobre la
            existencia de otras fuentes de información sobre un tema concreto, y la inclusión de un enlace no implica
            la aprobación de la página web enlazada por parte de LA CLÍNICA.
          </p>
          <p>
            <strong>8.3.</strong> LA CLÍNICA tan sólo autoriza menciones a sus contenidos en otras sedes Web, con
            el tratamiento que éstas consideren siempre que sea respetuoso y cumpla la legislación vigente.
          </p>

          <h2>9. Protección de Datos Personales</h2>
          <p>
            <strong>9.1.</strong> LA CLÍNICA adopta las medidas técnicas y organizativas necesarias para garantizar
            la protección de los datos de carácter personal y evitar su alteración, pérdida, tratamiento y/o acceso
            no autorizado, conforme a lo establecido por la legislación española y europea de Protección de Datos
            de Carácter Personal.
          </p>
          <p>
            <strong>9.2.</strong> El usuario podrá proporcionar a LA CLÍNICA sus datos de carácter personal a través
            de los distintos formularios que a tal efecto aparecen en la Web. Dichos formularios incorporan un texto
            legal en materia de protección de datos personales que da cumplimiento a las exigencias establecidas en
            el RGPD.
          </p>
          <p>
            <strong>9.3.</strong> Rogamos lea atentamente los textos legales antes de facilitar sus datos de carácter
            personal.
          </p>

          <h2>10. Ley y jurisdicción</h2>
          <p>
            Todas las cuestiones que se susciten entre LA CLÍNICA y el usuario relativas a la interpretación,
            cumplimiento y validez del presente Aviso Legal se regirán por sus propias cláusulas y, en lo que en
            ellas no estuviere previsto, de acuerdo con la legislación española, sometiéndose expresamente las
            partes a la jurisdicción de los Juzgados y Tribunales del domicilio de LA CLÍNICA.
          </p>

          <h2>Registro sanitario</h2>
          <p>
            Clínica Dental Pina cuenta con el número de registro sanitario{" "}
            <strong>E43641950</strong> otorgado por las autoridades sanitarias competentes.
          </p>
        </div>
      </div>
    </div>
  );
}
